/**
 * @typedef { import('../../time.js').YearMonthPeriod } YearMonthPeriod
 * @typedef { import('../../time.js').YearMonthPeriodObject } YearMonthPeriodObject
 * @typedef { import('../../time.js').YearMonth } YearMonth
 * @typedef { import('./retention_report.js').Report } Report
 * @typedef { import('./retention_report.js').Cohort } Cohort
 */

import {getQuartileName} from './stringer.js';

/**
 * @param {number} quartileNumber
 * @param {Report} report
 * @returns {string}
 */
export function convertRetentionReportToQuartileTableString(quartileNumber, report) {
  let str = "quartile,cohort,login_month,players\n";

  const period = report.getPeriod();

  const beginMonth = period.getBegin();
  const endMonth   = period.getEnd();

  for(let month = beginMonth; month.isBefore(endMonth); month = month.getNext()) {
    const cohort = report.getCohortByMonth(month);
    const cohortStr = convertCohortToMetricString(cohort, quartileNumber, endMonth);
    str += cohortStr + "\n";
  }

  return str;
}

/**
 * @param {Cohort} cohort
 * @param {number} quartileNumber
 * @param {YearMonth} endMonth
 * @returns {string}
 */
function convertCohortToMetricString(cohort, quartileNumber, endMonth) {
  /** @type {string[]} */
  const strs = [
    convertMetricToString(cohort, quartileNumber, cohort.getYearMonth(), cohort.getSize())
  ];

  const metricBeginMonth = cohort.getYearMonth().getNext();
  for(let month = metricBeginMonth; month.isBefore(endMonth); month = month.getNext()) {
    const value = cohort.getMetricValueByMonth(month);
    const str = convertMetricToString(cohort, quartileNumber, month, value);
    strs.push(str);
  }

  return strs.join("\n");
}

/**
 * @param {Cohort} cohort
 * @param {number} quartileNumber
 * @param {YearMonth} metricMonth
 * @param {number} metricValue
 * @returns {string}
 */
function convertMetricToString(cohort, quartileNumber, metricMonth, metricValue) {
  const parts = [
    getQuartileName(quartileNumber),
    cohort.getName(),
    metricMonth.toString(),
    metricValue,
  ];

  return parts.join(',');
}
